import React from 'react'
import { Form, Input, Collapse } from 'antd'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'
import styles from './SeoFields.module.scss'

const { Panel } = Collapse

interface ISeoFieldsProps {
  collapsed?: boolean
  defaultOpen?: boolean
  panelHeaderClassName?: string
  formItemClassName?: string
  inputClassName?: string
  textareaClassName?: string
}

export const SeoFields: React.FC<ISeoFieldsProps> = React.memo(({
  collapsed = true,
  defaultOpen = true,
  panelHeaderClassName,
  formItemClassName,
  inputClassName,
  textareaClassName
}) => {
  const role = useAppSelector(appSelectors.selectRole)

  // Only show SEO fields for ADMIN role
  if (role !== 'ADMIN') {
    return null
  }

  const seoFieldsContent = (
    <>
      <Form.Item
        label='Title'
        name={['seoInfo', 'title']}
        hasFeedback
        style={{ marginBottom: '10px' }}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        labelAlign='left'
        className={formItemClassName}
        rules={[
          {
            whitespace: true,
            message: 'Введите что-то кроме пробелов'
          }
        ]}
      >
        <Input className={inputClassName} />
      </Form.Item>

      <Form.Item
        label='Desc'
        name={['seoInfo', 'desc']}
        hasFeedback
        style={{ marginBottom: '10px' }}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        labelAlign='left'
        className={formItemClassName}
        rules={[
          {
            whitespace: true,
            message: 'Введите что-то кроме пробелов'
          }
        ]}
      >
        <Input.TextArea className={textareaClassName || styles.formTextarea} />
      </Form.Item>

      <Form.Item
        label='H1'
        name={['seoInfo', 'h1']}
        hasFeedback
        style={{ marginBottom: '10px' }}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        labelAlign='left'
        className={formItemClassName}
        rules={[
          {
            whitespace: true,
            message: 'Введите что-то кроме пробелов'
          }
        ]}
      >
        <Input className={inputClassName} />
      </Form.Item>

      <Form.Item
        label='SEO text'
        name={['seoInfo', 'seoText']}
        hasFeedback
        style={{ marginBottom: '10px' }}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        labelAlign='left'
        className={formItemClassName}
        rules={[
          {
            whitespace: true,
            message: 'Введите что-то кроме пробелов'
          }
        ]}
      >
        <Input.TextArea className={textareaClassName || styles.formTextarea} />
      </Form.Item>
    </>
  )

  if (!collapsed) {
    return <div className={styles.seoFieldsWrapper}>{seoFieldsContent}</div>
  }

  return (
    <Collapse defaultActiveKey={defaultOpen ? ['1'] : []}>
      <Panel
        header='SEO'
        key='1'
        className={panelHeaderClassName || styles.panelHeader}
      >
        {seoFieldsContent}
      </Panel>
    </Collapse>
  )
})

SeoFields.displayName = 'SeoFields'